import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get_tab as _get_tab } from 'api/payroll/salary-scheme/detail';
import tab1Attendance from './tab1-attendance';
import { tabPaneArr } from './conf';
import rdiff from 'recursive-diff';
export default {
  name: 'step2',
  components: {
    tab1Attendance: tab1Attendance
  },
  data: function data() {
    return {
      arr: [],
      active: 0,
      activeObj: {},
      scheme_id: this.$route.params.id,
      isRoute: false,
      loading: false
    };
  },
  mounted: function mounted() {
    this.get_tab();
    this.preventBack();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    window.removeEventListener('popstate', window.pushStateFun, false);
    var data = this.activeObj.data;
    if (this.isRoute) {
      next();
    } else {
      var diff = rdiff.getDiff(data.cInfo, data.info);
      if (!diff.length) next();else {
        this.$confirm(this.$t('payroll_management_28'), this.$t('payroll_management_27'), {
          confirmButtonText: this.$t('submit_btn'),
          cancelButtonText: this.$t('cancel_btn'),
          type: 'warning'
        }).then(function () {
          next();
        }).catch(function () {});
      }
    }
  },
  methods: {
    preventBack: function preventBack() {
      var this_ = this;
      window.pushStateFun = function () {
        var data = this_.activeObj.data;
        var diff = rdiff.getDiff(data.cInfo, data.info);
        if (!diff.length) this_.handlerBack();else {
          this_.$confirm(this_.$t('payroll_management_28'), this_.$t('payroll_management_27'), {
            confirmButtonText: this_.$t('submit_btn'),
            cancelButtonText: this_.$t('cancel_btn'),
            type: 'warning'
          }).then(function () {
            this_.isRoute = true;
            this_.handlerBack();
          }).catch(function () {
            var state = {
              title: null,
              url: document.UTL // 要禁掉的页面
            };
            /*
                三个参数：
                state：一个与指定网址相关的状态对象，popstate事件触发时，该对象会传入回调函数。如果不需要这个对象，此处可以填null。
                title：新页面的标题，但是所有浏览器目前都忽略这个值，因此这里可以填null。
                url：新的网址，必须与当前页面处在同一个域。浏览器的地址栏将显示这个网址。
              */
            window.history.pushState(state, null, document.UTL); // 要禁掉的页面
          });
        }
      };

      var state = {
        title: null,
        url: document.UTL // 要禁掉的页面
      };

      window.history.pushState(state, null, document.UTL); // 要禁掉的页面
      window.addEventListener('popstate', window.pushStateFun, false);
    },
    resetScroll: function resetScroll() {
      var _this = this;
      this.$nextTick(function () {
        var el = _this.$refs.wrapBox;
        if (el) el.scrollTop = 0;
      });
    },
    get_tab: function get_tab() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.loading = true;
              _this2.resetScroll();
              _context.prev = 2;
              _context.next = 5;
              return _get_tab({
                payroll_sub_project_scheme_id: _this2.scheme_id
              });
            case 5:
              res = _context.sent;
              if (res && res.code === 1) {
                _this2.arr = res.data.map(function (v) {
                  var item = tabPaneArr.filter(function (v1) {
                    return v1.id === v.id;
                  })[0];
                  return _objectSpread(_objectSpread({}, v), item);
                });
                _this2.activeObj = _this2.arr[_this2.active];
              }
            case 7:
              _context.prev = 7;
              _this2.loading = false;
              return _context.finish(7);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2,, 7, 10]]);
      }))();
    },
    prev: function prev() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.runStepSave();
            case 2:
              res = _context2.sent;
              if (!(!res || res.code !== 1)) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              _this3.active--;
              _this3.activeObj = _this3.arr[_this3.active];
              _this3.resetScroll();
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    next: function next() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this4.runStepSave();
            case 2:
              res = _context3.sent;
              if (!(!res || res.code !== 1)) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("return");
            case 5:
              _this4.active++;
              _this4.activeObj = _this4.arr[_this4.active];
              _this4.resetScroll();
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    save: function save() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this5.runStepSave();
            case 2:
              res = _context4.sent;
              if (!(!res || res.code !== 1)) {
                _context4.next = 5;
                break;
              }
              return _context4.abrupt("return");
            case 5:
              _this5.$message.success(res.message);
              _this5.isRoute = true;
              _this5.$router.push({
                path: '/payroll/salary-scheme'
              });
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    runStepSave: function runStepSave() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.loading = true;
              _context5.prev = 1;
              _context5.next = 4;
              return _this6.$refs[_this6.activeObj.name].saveData();
            case 4:
              return _context5.abrupt("return", _context5.sent);
            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](1);
              // eslint-disable-next-line no-console
              console.error(_context5.t0);
              return _context5.abrupt("return", null);
            case 11:
              _context5.prev = 11;
              _this6.loading = false;
              return _context5.finish(11);
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[1, 7, 11, 14]]);
      }))();
    },
    handlerBack: function handlerBack() {
      if (this.loading) return;
      this.$router.push({
        path: '/payroll/salary-scheme'
      });
    }
  }
};